import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../constants/analyticsIds';
import logo from '../../../PINS.png';

const Logo = () => <img alt="PINS Advantage Logo" src={logo} style={{ height: '40px', width: 'auto' }} />;

const LogoBox = ({ to }) => {
  if (to === '/') {
    return (
      <a href={window.location.href.replace(/v2.*/, '')}>
        <Logo />
      </a>
    );
  }

  return (
    <Link
      data-analytics-id={analyticsIds.header.pinsLogoButton}
      dusk={analyticsIds.header.pinsLogoButton}
      to={to}
    >
      <Logo />
    </Link>
  );
};

LogoBox.propTypes = { to: PropTypes.string };

export default LogoBox;
